/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';
const SingleSizeIllustrationFeedbackActiveVeryHappy = (
  props: SVGProps<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 42 42"
    data-xds="SingleSizeIllustrationFeedbackActiveVeryHappy"
    role="presentation"
    {...props}
  >
    <g clipPath="url(#clip0_864_206)">
      <path
        fill="#27DBA8"
        fillRule="evenodd"
        d="M42.035 21c0 11.598-9.41 21-21.017 21S0 32.598 0 21 9.41 0 21.018 0c11.607 0 21.017 9.402 21.017 21"
        clipRule="evenodd"
      />
      <path
        fill="#161C24"
        d="M31.982 17.148a.75.75 0 0 1 .75.75c0 6.381-5.173 11.554-11.554 11.554S9.625 24.28 9.625 17.898a.75.75 0 0 1 1.5 0c0 5.553 4.5 10.054 10.053 10.054 5.552 0 10.054-4.501 10.054-10.054a.75.75 0 0 1 .75-.75M15.424 1.183l.256.01c3.614.195 6.165 2.931 6.234 7.434l.02 1.726.01 1.237c.01 1.868.008 3.841-.002 5.796l-.028 3.433a.75.75 0 0 1-1.5-.018l.018-1.965c.015-1.933.022-3.916.017-5.823l-.01-2.038-.017-1.77-.008-.555c-.057-3.725-1.998-5.807-4.815-5.96-2.67-.144-5.288 1.533-6.083 4.084a.75.75 0 0 1-1.432-.447c.981-3.146 4.098-5.207 7.34-5.144m.137 11.86c1.18 0 1.92 1.336 1.92 2.861a.75.75 0 0 1-1.5 0c0-.807-.308-1.362-.42-1.362-.114 0-.421.555-.421 1.362a.75.75 0 0 1-1.5 0c0-1.525.74-2.862 1.92-2.862m11.244 0c1.18 0 1.921 1.336 1.921 2.861a.75.75 0 0 1-1.5 0c0-.806-.308-1.362-.421-1.362s-.421.555-.421 1.362a.75.75 0 0 1-1.5 0c0-1.525.74-2.862 1.921-2.862"
      />
    </g>
    <defs>
      <clipPath id="clip0_864_206">
        <path fill="#fff" d="M0 0h42v42H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SingleSizeIllustrationFeedbackActiveVeryHappy;
